import type { RouteDefinition } from "../route-definition.ts";

export const adminOperationsRoutes = {
  "admin.lobbies": {
    path: "/admin/lobbies",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.tournaments": {
    path: "/admin/tournaments",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.coaching": {
    path: "/admin/coaching",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.jobs": {
    path: "/admin/operations/jobs",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.reporters": {
    path: "/admin/operations/reporters",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.check": {
    path: "/admin/operations/checks/:checkId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.request": {
    path: "/admin/episode-requests/:requestId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.round": {
    path: "/admin/rounds/:roundId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.episode": {
    path: "/admin/episodes/:episodeId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.newLobby": {
    path: "/admin/lobbies/new",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.lobby": {
    path: "/admin/lobbies/:lobbyId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.playSession": {
    path: "/admin/play-sessions/:sessionId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.newTournament": {
    path: "/admin/tournaments/new",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.tournament": {
    path: "/admin/tournaments/:tournamentId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.editTournament": {
    path: "/admin/tournaments/:tournamentId/edit",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coachingSession": {
    path: "/admin/coaching/:sessionId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coachingEpisode": {
    path: "/admin/coaching/episodes/:episodeId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
